import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { BannerLearnMore } from './helperContent';
import { ModalWindow, BannerTypes } from './../../constants/actionType';
import { InHomeUtils } from './../../util/inhomeUtils';
import SuppProfile from './../supp/suppProfile'
import { ModalTitle, ModalBody, ModalFooter } from '@vds/modals';
import { Title } from '@vds/typography';
import { connect } from "react-redux";

class banner extends React.PureComponent {
    constructor(props) {
        super(props);
        this.isReskin = this.props.buildProductState.isReskin && this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.EnableReskin === 'Y';
    }

    getStandAloneType = (data) => {
        if(data.serviceHeaders && data.serviceHeaders.servicehead[0] && data.serviceHeaders.servicehead[0].prodType){
            const prodType = data.serviceHeaders.servicehead[0].prodType
            switch (prodType) {
                case 'FTTPD':
                    return 'Verizon Fios Internet'
                case 'BASIC':
                    return 'Verizon Fios Tv'
                default:
                    return '';
            }
        }
    }

    render() {
        let bannerContent = '';
        let bannerOverlayContent = '';

        let isLearnMore = false;
        let isConnectionFlow = false;
        let isSeamLess = false;
        
        let domainSetByMotionPoint = false;
        let domainURL = window.location.origin; 
        
        if (domainURL === "https://www.verizon.com" || domainURL === "https://wwwordering-prod-east-yz.vpc.verizon.com" || domainURL === "https://wwwordering-prod-west-yz.vpc.verizon.com" ) {
            domainURL = "https://www.verizon.com";
        }
        else if (domainURL === "https://espanol.verizon.com") {
            domainURL = "https://www.verizon.com";
            domainSetByMotionPoint=true;
        }
        else if (domainURL === "https://www98.verizon.com") {
            domainURL = "https://www98.verizon.com";
        }        
        else {
            domainURL = "https://sales-bau-sit2-publisher.ebiz.verizon.com";
        }

        let deviceType = "web";
        let bannerContainercss = 'w_fios-plan';
        let bannerContainercss_EC = 'w_fios-plan_ec';
        let bannerImageCss = 'accordion-hero_image ';
        let bannerContentMobile = '';
        let userAgent = window.navigator.userAgent.toLowerCase();
        if (userAgent && (userAgent.indexOf('android') !== -1 || userAgent.indexOf('iphone') !== -1)) {
            deviceType = "mobile";
            bannerImageCss = 'accordion-hero_image hide-for-small-up';
        }
        if(userAgent && userAgent.indexOf('ipad')!==-1){ //for banner data same as mobile
            deviceType="ipad"
        }

        let aemImagePath = '/content/dam/verizon/personal/accordion-images/banners/';
        let bannerTitle = '';
        let bannertopcontent = '';
        let bannerBodyContent = '';
        let bannerImg = '';
        let bannerImgMobile = "";
        let overlayImg = '';
        let bannerHeaderText = '';
        let fName = this.props.firstName ? this.props.firstName : '';
        let lName = this.props.lastName ? this.props.lastName : '';
        const { movesTitleContent } = this.props
        let isMoves = false;
        let isFlash = false;
        let isFCP = false;
        let isVecFlow = false;
        let isPreholidayOffers = false;
        let isBlackFriday2021=false;
        let isHoliday2021=false;
        let isDisneyBundle=false;
        let isSimpliBundle=false;
        let bannerText_supp =   (this.props?.buildProductState?.isECMNEnabled) ? 'text-white-supp' : 'text-white'
        //default values on fetchBanners call failure
         //moveChange
        if(this.props.flowType==="MV") {
            bannerTitle = "Let's get your move started, " + fName +" "+ lName + ".";
        } 
        else {
            bannerTitle = 'Welcome to Verizon Fios.';
            if(!(this.props?.buildProductState?.isECMNEnabled)){
            bannerImg = domainURL + aemImagePath + 'resume.jpg';}
        }

        if (InHomeUtils.isNotEmpty(this.props.lstBanners)) {
            var bannerType = '';
            if (InHomeUtils.isNotEmpty(this.props.bannerType)) {
                bannerType = this.props.bannerType;
            }
            switch (bannerType) {
                case BannerTypes.move:
                    if (this.props.lstBanners[bannerType] !== undefined && this.props.lstBanners[bannerType] !== null) {
                        bannerContent = this.props.lstBanners[bannerType];
                        isSeamLess = true;
                    }
                    break;
                case BannerTypes.moves_buildProduct:
                    let title = ''
                    if(movesTitleContent && movesTitleContent.cartData && movesTitleContent.cartData[0]){
                        if( movesTitleContent.cartData[0].serviceHeaders && movesTitleContent.cartData[0].serviceHeaders.title ){
                            title = movesTitleContent.cartData[0].serviceHeaders ? movesTitleContent.cartData[0].serviceHeaders.title : ''
                        }else{
                            //Standalone
                            title = this.getStandAloneType(movesTitleContent.cartData[0])
                        }
                    }
                    if (this.props.lstBanners[bannerType]) {
                        bannerContent = this.props.lstBanners[bannerType];
                        bannerContent.bannerheadline = title ?  ('Your ' + title) : '';
                        isSeamLess = true;
                    }
                    bannerTitle = 'Feel right at home faster.';
                    bannerContent.bannercontent = "Verizon Fios makes moving easy. Take the 100% fiber-optic network with you to your new home.";  
                    break;
                case BannerTypes.VecOrder:
                     isVecFlow =true;
                     bannerContent = this.props.lstBanners[bannerType];
                     //bannerContent="";
                     //bannerImg = domainURL + aemImagePath +'VEC_Banner_Desktop.jpg';
                     bannerImg="";
                    break; 
                default:
                    //set the default banner, if bannerType is not identified, whenever we add new banners, we need to update this
                    
                    if (this.props.lstBanners[bannerType] !== undefined && this.props.lstBanners[bannerType] !== null) {
                        bannerContent = this.props.lstBanners[bannerType];
                        if(bannerType === BannerTypes.ResumeCart){
                            bannerContainercss = 'w_fios-plan resume';
                        }else if(bannerType === BannerTypes.connections){
                            isConnectionFlow = true;
                        }
                    } else if (this.props.lstBanners["default"] !== undefined && this.props.lstBanners["default"] !== null) {
                        bannerContent = this.props.lstBanners["default"];
                    }
                    else if(bannerType === BannerTypes.Employee){
                        bannerBodyContent="";
                    }
                    break;
            }

            isFCP = bannerType === BannerTypes.FCP;
            
            if (InHomeUtils.isNotEmpty(bannerContent)) {
                if (InHomeUtils.isNotEmpty(bannerContent.bannerheadline)){
                    bannerTitle = bannerContent.bannerheadline;                    
                    if(isConnectionFlow && InHomeUtils.isNotEmpty(this.props.headerText)){
                        bannerTitle = this.props.headerText;
                    }
                }

                if(InHomeUtils.isNotEmpty(bannerContent.bannertopcontent)) {
                    bannertopcontent = bannerContent.bannertopcontent;
                }
                
                bannerBodyContent = "";
                if (InHomeUtils.isNotEmpty(bannerContent.bannercontent)){
                    bannerBodyContent = bannerContent.bannercontent;
                }
                if (InHomeUtils.isNotEmpty(bannerContent.imagePath)){
                    if(domainSetByMotionPoint){
                        bannerImg = aemImagePath + bannerContent.imagePath;
                    }
                    else {
                        bannerImg = domainURL + aemImagePath + bannerContent.imagePath;
                    }
                }
                if (InHomeUtils.isNotEmpty(bannerContent.imagePathMobile)){
                    if(domainSetByMotionPoint){
                        bannerImgMobile = aemImagePath + bannerContent.imagePathMobile;
                    }
                    else {
                        bannerImgMobile = domainURL + aemImagePath + bannerContent.imagePathMobile;
                    }
                }
                if(InHomeUtils.isNotEmpty(bannerContent.bannercontentMobile)){
                    bannerContentMobile = bannerContent.bannercontentMobile;
                }
               
               if (InHomeUtils.isNotEmpty(bannerContent.imagePathLearnMore)){
                    if(domainSetByMotionPoint){
                        overlayImg = aemImagePath + bannerContent.imagePathLearnMore;
                    } 
                    else {
                        overlayImg = domainURL + aemImagePath + bannerContent.imagePathLearnMore;
                    }
                }
    
                if (InHomeUtils.isNotEmpty(bannerContent.isLearnMore) && bannerContent.isLearnMore === 'true') {
                    isLearnMore = true;
                }
            }
        }
        if (InHomeUtils.isNotNull(this.props.modalWindow) && this.props.modalWindow.modalId === "SUPPBANNER" && this.props.flowType==="SUPP") {
                  bannerOverlayContent = <React.Fragment>
            <ModalTitle>
                <Title size="large" viewport={InHomeUtils.getdeviceType()} primitive="h6" color="black">Current Cart</Title>                                        
            </ModalTitle>
            <ModalBody><div className="modal-wrap">
                    <div className="tiny-p-95 small-p-95 medium-p-100 right tiny-margin-vert-micro small-margin-vert-zero bg-white opened">
                        <div className="" data-modal-content="" style={{ maxHeight: '100%', width: '100%'}}>
                            <SuppProfile/>
                </div>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter buttonData={{    
                close: {
                    width: 'auto',
                    children: "Close",
                    onClick: () => {
                        document?.getElementById('close-button')?.click();
                    }
                }
            }}
            />
        </React.Fragment> 
        }

        if (InHomeUtils.isNotNull(this.props.modalWindow) && this.props.modalWindow.modalId === ModalWindow.ids.banner) {
               bannerOverlayContent = <BannerLearnMore bannerContent={bannerContent} imagePathLearnMore={overlayImg} closeModel={this.props.closeModel} oneMonthInternet={this.props.oneMonthInternet} VGC200={this.props.VGC200} VGC100={this.props.VGC100}/>;            
        }
        isFlash = bannerType === BannerTypes.Flash || bannerType === BannerTypes.JDOffer;
        bannerHeaderText = <h1 className={bannerText_supp}>{ReactHtmlParser(bannerTitle)}</h1>
        if (this.props.flowType === "MV" && window.location.pathname.indexOf('moves/landing') > -1) {
            isMoves = true
            bannerHeaderText = <h1 className="text-black moves-head-text" id="moveHeaderTxt" data-cs-mask>{bannerTitle}</h1>
            bannerContainercss="w_fios-plan moves";
        }
        if(bannerType === BannerTypes.connections)
        {   
        bannerHeaderText = <h1 className="text-black">{ReactHtmlParser(bannerTitle)}</h1>
        }
        if(bannerType === BannerTypes.VecOrder){
            isVecFlow=true;
           // bannerHeaderText = <h1>{ReactHtmlParser(bannerTitle)}</h1>
            bannerHeaderText="";
            //bannerContainercss="w_fios-plan discoveryPlus";
            bannerContainercss="";
        }
        if(this.props.flowType==="SUPP"){
            const duedate = `Installation date: ${this.props.dateToDisplay}`;
            bannerBodyContent=`Your order number is : ${this.props.baseOrderMon} <br/> ${this.props.dateToDisplay ? duedate : ""}`;
            bannerContainercss="w_fios-plan stadia";
            bannerContainercss_EC="w_fios-plan_ec stadia";
            bannerContentMobile=`Your order number is: ${this.props.baseOrderMon} <br/> ${this.props.dateToDisplay ? duedate : ""}`;
        } 
        if((bannerType === BannerTypes.PreholidayOffersGig) || (bannerType === BannerTypes.PreholidayOffersGigClassic) || (bannerType === BannerTypes.PreholidayOffersNonGig) ||(bannerType === BannerTypes.PreholidayOffersNonGigClassic) || (bannerType === BannerTypes.PreholidayOffersSOCNOCGig) ||(bannerType === BannerTypes.PreholidayOffersSOCNOCGigClassic) || (bannerType ===  BannerTypes.PreholidayOffersSOCNOCNonGig)||(bannerType ===  BannerTypes.PreholidayOffersSOCNOCNonGigClassic)){
           if(deviceType =='web' || deviceType =='ipad'){
             isPreholidayOffers=true;
           }
             bannerHeaderText = <h3>{ReactHtmlParser(bannerTitle)}</h3>
             if(this.props.moverBannerNC){
                bannerImg =bannerImgMobile= domainURL+aemImagePath + "movesbanner_v3.jpg"; 
                isPreholidayOffers=false;
                bannerHeaderText = <h1 className={bannerText_supp}>{ReactHtmlParser(bannerTitle)}</h1>
            }
            // bannerContainercss="w_fios-plan discoveryPlus";
        }   
        if((bannerType === BannerTypes.BlackFriday2021Gig) || (bannerType === BannerTypes.BlackFriday2021IONTGig) || (bannerType === BannerTypes.BlackFriday2021IONTNonGig) || (bannerType === BannerTypes.BlackFriday2021NonGig)){
            bannerHeaderText = <h1>{ReactHtmlParser(bannerTitle)}</h1>
            bannerContainercss= this.props.runtimeKey && this.props.runtimeKey.showHolidaytimer && this.props.runtimeKey.showHolidaytimer === "Y" && deviceType === "mobile" ? "w_fios-plan holiday  count-down-ribbon":"w_fios-plan holiday";
            bannerImageCss = 'accordion-hero_image';
            isBlackFriday2021 = true;
            if(deviceType =='mobile' || deviceType =='ipad'){
                 isLearnMore = true;
            }
        }
        if((bannerType === BannerTypes.Holiday2021Gig) || (bannerType === BannerTypes.Holiday2021IONTGig) || (bannerType === BannerTypes.Holiday2021IONTNonGig) || (bannerType === BannerTypes.Holiday2021NonGig)){
            bannerHeaderText = <h1 className="text-black">{ReactHtmlParser(bannerTitle)}</h1>
            bannerContainercss= this.props.runtimeKey && this.props.runtimeKey.showHolidaytimer && this.props.runtimeKey.showHolidaytimer === "Y" && deviceType === "mobile" ? "w_fios-plan holiday count-down-ribbon":"w_fios-plan holiday ";
            bannerImageCss = 'accordion-hero_image';
            isHoliday2021=true;
            if(deviceType =='mobile' || deviceType =='ipad'){
                 isLearnMore = true;
            }
        }
        if((bannerType === BannerTypes.SimpliSafe8PieceBundle) || (bannerType === BannerTypes.SimpliSafe8PieceBundleSOCNOCGIG) || (bannerType === BannerTypes.SimpliSafe8PieceBundleNONGIG) || (bannerType === BannerTypes.SimpliSafe8PieceBundleSOCNOCNONGIG)){
            bannerHeaderText = <h1 className="text-black">{ReactHtmlParser(bannerTitle)}</h1>
            bannerContainercss = this.props.runtimeKey && this.props.runtimeKey.showHolidaytimer && this.props.runtimeKey.showHolidaytimer === "Y" ? "w_fios-plan holiday count-down-ribbon":"w_fios-plan holiday ";
            bannerImageCss = 'accordion-hero_image';
            isSimpliBundle=true;
            if(deviceType =='mobile' || deviceType =='ipad'){
                 isLearnMore = true;
            }
        }
        if((bannerType === BannerTypes.DisneyBundleGig) || (bannerType === BannerTypes.DisneyBundleIONTGig) || (bannerType === BannerTypes.DisneyBundleIONTNonGig) || (bannerType === BannerTypes.DisneyBundleNonGig) || (bannerType === BannerTypes.DisneyBundleIONTNonGig200) || (bannerType === BannerTypes.DisneyBundleIONTGig200)){
            bannerHeaderText = <h1 className="text-black">{ReactHtmlParser(bannerTitle)}</h1>
            bannerContainercss= this.props.runtimeKey && this.props.runtimeKey.showHolidaytimer && this.props.runtimeKey.showHolidaytimer === "Y" && deviceType === "mobile" ? "w_fios-plan holiday count-down-ribbon":"w_fios-plan holiday ";
            bannerImageCss = 'accordion-hero_image';
            isDisneyBundle=true;
            if(deviceType =='mobile' || deviceType =='ipad'){
                 isLearnMore = true;
            }
        }
        // if((bannerType === BannerTypes.SimpliSafe8PieceBundle) || (bannerType === BannerTypes.SimpliSafe8PieceBundleSOCNOCGIG) || (bannerType === BannerTypes.SimpliSafe8PieceBundleNONGIG) || (bannerType === BannerTypes.SimpliSafe8PieceBundleSOCNOCNONGIG)){
        //     bannerHeaderText = <h1 className="text-black">{ReactHtmlParser(bannerTitle)}</h1>
        //     bannerContainercss= "w_fios-plan holiday ";
        //     bannerImageCss = 'accordion-hero_image';
        //     isDisneyBundle=true;
        //     if(deviceType =='mobile' || deviceType =='ipad'){
        //          isLearnMore = true;
        //     }
        // }
        let oneMonthIntText = "<br/>Plus, one month of Internet on us.";
        if(this.props.oneMonthInternet && InHomeUtils.isNotNull(bannerBodyContent)){
            bannerBodyContent = bannerBodyContent + oneMonthIntText;
        }
        let VZGC100Text = "<br/>Online Exclusive: Receive an additional $100 Verizon Gift Card with Gigabit Connection.";
        if(this.props.VGC100 && InHomeUtils.isNotNull(bannerBodyContent) && ((bannerType === BannerTypes.DisneyBundleGig) || (bannerType === BannerTypes.DisneyBundleIONTGig) || (bannerType === BannerTypes.DisneyBundleIONTNonGig) || (bannerType === BannerTypes.DisneyBundleNonGig))){
            bannerBodyContent = bannerBodyContent + VZGC100Text;
        }
        let VGC200Text = " and a $200 Verizon Gift Card.";
        if(this.props.VGC200 && InHomeUtils.isNotNull(bannerBodyContent)){

            bannerBodyContent = bannerBodyContent + VGC200Text;
            
        }
        return (
            <>
           <div className={(this.isReskin && !isVecFlow) ? "row reskinBannerPortion ":"hide"} id={isConnectionFlow ? 'connectionHeader' : isFlash ? 'flashHeader' : isFCP ? 'fcpHeader' : 'bauHeader'}>
                <div className={this.isReskin ? " " : " columns padding-all-zero "}>
                    <div className={(this.props?.buildProductState?.isECMNEnabled) ? bannerContainercss_EC : bannerContainercss} id="jmpBannertext">
                        <div className="banner-header">{bannerHeaderText}</div>                            
                    </div>
                </div>
            </div>
            </>
        );
    }
}

// export default banner;


const mapStateToProps = (state) => {
    return {
        buildProductState: state.buildProduct,
        appState: state.app,
        runtimeKey:state.loopQual.runtimeKey, 
        lqState: state.loopQual,
    }
}
export default connect(
    mapStateToProps
)(banner);